import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export const ValidateOdometerReadingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const distanceTravelled = control.get('distanceTravelled');
    const previousReading = control.get('previousReading');
    
    return previousReading && distanceTravelled && (distanceTravelled.value <= previousReading.value) ? { ValidateOdometerReading: true } : null;
};